import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component } from 'react';
import requireIf from 'react-required-if';

import formatPrice from '../../../util/formatPrice';

import Checkbox from '../Atoms/Checkbox';
import Image from '../Atoms/Image';
import { DEFAULT_CRITICAL_BACKUP_CURRENCY } from '../../../util/currency';

const propTypes = exact({
  currencySymbol: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  hasBankPaymentOption: PropTypes.bool,
  hasDepositOption: PropTypes.bool,
  optionBankDepositText: PropTypes.string,
  optionBankFullText: PropTypes.string,
  optionBankOptionText: PropTypes.string,
  optionCardDepositText: PropTypes.string,
  optionCardFullText: PropTypes.string,
  optionCardOptionText: PropTypes.string,
  preferredCardImage: PropTypes.object,
  price: PropTypes.number.isRequired,
  priceDeposit: requireIf(PropTypes.number, (props) => props.hasDepositOption),
  priceText: PropTypes.string,
  selectedValue: PropTypes.string.isRequired,
});

const defaultProps = {
  hasBankPaymentOption: false,
  hasDepositOption: false,
  optionBankDepositText: 'Bank transfer - Pay Deposit',
  optionBankFullText: 'Bank transfer - Pay in full',
  optionBankOptionText: 'Bank Transfer',
  optionCardDepositText: 'Card - Pay deposit',
  optionCardFullText: 'Card - Pay in full',
  optionCardOptionText: 'Card',
  preferredCardImage: null,
  priceDeposit: null,
  priceText: 'Total payable',
};

const paymentTypes = {
  card: '0',
  bankTransfer: '1',
};

export const paymentOptions = {
  cardPayInFull: '0',
  cardPayDeposit: '1',
  bankTransferPayInFull: '2',
  bankTransferPayDeposit: '3',
};

class PaymentOptions extends Component {
  constructor(props) {
    super(props);

    this.handlePaymentTypeChange = this.handlePaymentTypeChange.bind(this);

    this.state = {
      paymentType: '0',
    };
  }

  handlePaymentTypeChange(paymentType) {
    this.props.handleChange(
      paymentType === paymentTypes.card
        ? paymentOptions.cardPayInFull
        : paymentOptions.bankTransferPayInFull
    );

    this.setState({
      paymentType,
    });
  }

  render() {
    return (
      <div className="PaymentOptions">
        <div className="PaymentOptions_column">
          <div className="PaymentOptions_price">
            <div className="PaymentOptions_content">
              <div className="PaymentOptions_priceContent">
                <span className="PaymentOptions_sup">{this.props.priceText}</span>
                <span className="PaymentOptions_total">
                  {this.props.currencySymbol || DEFAULT_CRITICAL_BACKUP_CURRENCY.symbol}
                  {formatPrice(Number(this.props.price))}
                </span>
              </div>
            </div>
          </div>
          <div className="PaymentOptions_payment">
            <div className="PaymentOptions_content">
              <div className="PaymentOptions_paymentContent">
                <div className="PaymentOptions_option">
                  <Checkbox
                    fieldID="paymentType.0"
                    fieldName="paymentType"
                    fieldValue={paymentTypes.card}
                    handleChange={(e) => this.handlePaymentTypeChange(e.target.value)}
                    inputType="radio"
                    isChecked={this.state.paymentType === paymentTypes.card}
                    modifier="ghost"
                    text={this.props.optionCardOptionText}
                  />
                </div>
                {this.props.hasBankPaymentOption && (
                  <div className="PaymentOptions_option">
                    <Checkbox
                      fieldID="paymentType.1"
                      fieldName="paymentType"
                      fieldValue={paymentTypes.bankTransfer}
                      handleChange={(e) => this.handlePaymentTypeChange(e.target.value)}
                      inputType="radio"
                      isChecked={this.state.paymentType === paymentTypes.bankTransfer}
                      modifier="ghost"
                      text={this.props.optionBankOptionText}
                    />
                  </div>
                )}
              </div>
              {this.props.hasDepositOption && (
                <div className="PaymentOptions_paymentContent">
                  {this.state.paymentType === paymentTypes.card && (
                    <>
                      <div className="PaymentOptions_option">
                        <Checkbox
                          fieldID="paymentFull.0"
                          fieldName="paymentFull"
                          fieldValue={paymentOptions.cardPayInFull}
                          handleChange={(e) => this.props.handleChange(e.target.value)}
                          inputType="radio"
                          isChecked={this.props.selectedValue === paymentOptions.cardPayInFull}
                          modifier="ghost"
                          text={this.props.optionCardFullText}
                        />
                      </div>
                      <div className="PaymentOptions_option">
                        <Checkbox
                          fieldID="paymentFull.1"
                          fieldName="paymentFull"
                          fieldValue={paymentOptions.cardPayDeposit}
                          handleChange={(e) => this.props.handleChange(e.target.value)}
                          inputType="radio"
                          isChecked={this.props.selectedValue === paymentOptions.cardPayDeposit}
                          modifier="ghost"
                          text={`${this.props.optionCardDepositText} ${
                            this.props.currencySymbol
                          }${formatPrice(this.props.priceDeposit)}`}
                        />
                      </div>
                    </>
                  )}
                  {this.props.hasBankPaymentOption &&
                    this.state.paymentType === paymentTypes.bankTransfer && (
                      <>
                        <div className="PaymentOptions_option">
                          <Checkbox
                            fieldID="paymentFull.2"
                            fieldName="paymentFull"
                            fieldValue={paymentOptions.bankTransferPayInFull}
                            handleChange={(e) => this.props.handleChange(e.target.value)}
                            inputType="radio"
                            isChecked={
                              this.props.selectedValue === paymentOptions.bankTransferPayInFull
                            }
                            modifier="ghost"
                            text={this.props.optionBankFullText}
                          />
                        </div>
                        <div className="PaymentOptions_option">
                          <Checkbox
                            fieldID="paymentFull.3"
                            fieldName="paymentFull"
                            fieldValue={paymentOptions.bankTransferPayDeposit}
                            handleChange={(e) => this.props.handleChange(e.target.value)}
                            inputType="radio"
                            isChecked={
                              this.props.selectedValue === paymentOptions.bankTransferPayDeposit
                            }
                            modifier="ghost"
                            text={`${this.props.optionBankDepositText} £${formatPrice(
                              this.props.priceDeposit
                            )}`}
                          />
                        </div>
                      </>
                    )}
                </div>
              )}
            </div>
          </div>
          {this.props.preferredCardImage && (
            <div className="PaymentOptions_card">
              <div className="PaymentOptions_content">
                <div className="PaymentOptions_image">
                  <Image {...this.props.preferredCardImage} useAspectRatio />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

PaymentOptions.propTypes = propTypes;
PaymentOptions.defaultProps = defaultProps;

export default PaymentOptions;
